const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const ChatUtils = {
    getMessageTime(message) {
        if (message.ts) {
            let date;
            if (typeof message.ts === 'string' || message.ts instanceof String) {
                date = new Date(message.ts);
            } else if (message.ts.$date) {
                date = new Date(message.ts.$date);
            }

            if (date) {
                const localHour = date.getHours().toString().padStart('2', '0');
                const localMinute = date.getMinutes().toString().padStart('2', '0');

                return `${localHour}:${localMinute}`;
            }
        }

        return null;
    },

    getResourceUrl(resource, history) {
        return history ? `${API_KEEPER}/ged/attach/${encodeURI(resource)}` : `${API_KEEPER}/chat/attach?title_link=${encodeURI(resource)}`;
    },

    getWebSocketUrl(chatUrl) {
        if (chatUrl.startsWith('http:')) {
            return 'ws:' + chatUrl.substring('http:'.length) + 'websocket'
        }

        if (chatUrl.startsWith('https:')) {
            return 'wss:' + chatUrl.substring('https:'.length) + 'websocket'
        }
    }
};

export default ChatUtils;